module.exports = __webpack_public_path__ + "static/media/appstore.200a1960.png";